import {
    deleteMsisdn,
    sendWelcomeSms,
    updateMsisdn,
    updateMsisdnStatus,
    updateMsisdnStatusAdmin
} from "../API/msisdnApi";
import React, {useEffect, useState} from "react";
import {toast} from "react-toastify";
import messageFromError from "../utils/errorUtils";
import {endOfMonth, format, startOfMonth} from "date-fns";
import useCompanyId from "../Hooks/useCompanyId";
import useClaims from "../Hooks/useClaims";
import {useTranslation} from "react-i18next";
import {
    ACTIVATE_DEACTIVATE_MSISDN,
    MANAGE_GEOFENCE_ASSIGNMENTS,
    REG_MSISDN,
    UNREG_MSISDN,
    UPDATE_MSISDN,
    UPDATE_MSISDN_STATUS,
    VIEW_MSISDN_LOCATIONS
} from "../Claims";
import MsisdnStatusDropdown from "./MsisdnStatusDropdown";
import {Badge, Col, Container, FormControl, FormLabel, Row} from "react-bootstrap";
import {colorForStatus, statusToString} from "../utils/msisdnUtils";
import ConditionalRender, {Fallback} from "./ConditionalRender";
import {
    faAddressCard,
    faClipboard,
    faCommentSms,
    faEdit,
    faLocationDot,
    faLock,
    faTrashCan
} from "@fortawesome/free-solid-svg-icons";
import ConfirmModal from "./Modals/ConfirmModal";
import ActionModal from "./Modals/ActionModals/ActionModal";
import ExtrasComponent from "./ExtrasComponent";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import MsisdnLocationsModal from "./Modals/MsisdnLocationsModal";
import Menu from "./core/Components/Menu/Menu";
import MenuItem from "./core/Components/Menu/MenuItem";
import useMyTranslation from "../Hooks/useMyTranslation";
import {getMSISDNConsumption} from "../API/companyApi";
import ManageZonePlanningModal from "./Modals/ManageZonePlanningModal";


export default function MsisdnRow({ msisdn, onMsisdnDeleted, onUpdated, geofences, onNeedGeofences }) {


    const [currentStatus, setCurrentStatus] = useState(msisdn.status)
    const [lockStatus, setLockStatus] = useState(msisdn.statusLocked)
    const [showConfirmDeletion, setShowConfirmDeletion] = useState(false)
    const [showConfirmDeletionSpinner, setShowConfirmDeletionSpinner] = useState(false)
    const [showChangeNameModal, setShowChangeNameModal] = useState(false)
    const [showViewLocationsModal, setShowViewLocationsModal] = useState(false)
    const [showZonePlanningModal, setShowZonePlanningModal] = useState(false)
    const [showLockUnlockStatus, setShowLockUnlockStatus] = useState(false)
    const [showChangeStatusConfirm, setShowChangeStatusConfirm] = useState(false);
    const [pendingStatus, setPendingStatus] = useState(null);
    const [temporaryStatus, setTemporaryStatus] = useState()
    const [lockActionSuggested, setLockActionSuggested] = useState(null)
    // const [externalId, setExternalId] = useState(msisdn.externalId || '');

    const [name, setName] = useState({ firstName: msisdn.firstName ?? "", middleName: msisdn.middleName ?? "", lastName: msisdn.lastName ?? "" })
    const [note, setNote] = useState(msisdn.note ?? "")
    const [consumptionCount, setConsumptionCount] = useState(0)
    const [isSendingWelcomeSms, setIsSendingWelcomeSms] = useState(false)

    const { t } = useTranslation()
    const tOperations = useMyTranslation('global.operations')

    const companyId = useCompanyId()
    const { hasClaim } = useClaims()

    async function updateStatus(status) {
        const previousStatus = currentStatus;
        setCurrentStatus(status)

        const newStatusMsisdn = {
            msisdn: msisdn.id,
            companyId: msisdn.companyId,
            status: status
        }
        try {
            await updateMsisdnStatus(newStatusMsisdn)
            toast.success("Updated", { autoClose: 1000, hideProgressBar: true })
            setTemporaryStatus(newStatusMsisdn)

            // const isLockSuggested = status === STATUS_NOT_ACTIVE && !lockStatus;
            // const isUnlockSuggested = status === STATUS_ACTIVE && lockStatus;

            // if (isLockSuggested || isUnlockSuggested) {
            //     setLockActionSuggested(isLockSuggested);
            //     setShowLockUnlockStatus(true);
            // }

        }
        catch (error) {
            toast.error(messageFromError(error))
            setCurrentStatus(previousStatus)
        }
    }



    async function lockUnlockAccount(lockStatuss) {
        const previousStatus = currentStatus;
        const previousLockStatus = lockStatus;
        setLockStatus(lockStatuss)
        const newStatusMsisdn = {
            msisdn: msisdn.id,
            status: previousStatus,
            statusLocked: lockStatuss
        }
        try {
            await updateMsisdnStatusAdmin(newStatusMsisdn)
            toast.success("Updated", { autoClose: 1000, hideProgressBar: true })
        }
        catch (error) {
            toast.error(messageFromError(error))
            setLockStatus(previousLockStatus)
        }

    }

    const [extrasList, setExtrasList] = useState([])

    async function update() {
        const toBeUpdated = { ...msisdn, firstName: name.firstName, lastName: name.lastName, middleName: name.middleName, note: note, extras: extrasList }
        await updateMsisdn(toBeUpdated)
    }

    function handleSendSmsClick(msisdn) {
        return async () => {
            if (isSendingWelcomeSms)
                return;

            setIsSendingWelcomeSms(true)
            try {
                await sendWelcomeSms(msisdn)
                toast.success(t('dialogs.notifications.sent'))
            }
            catch (error) {
                toast.error(messageFromError(error))
            }
            finally {
                setIsSendingWelcomeSms(false)
            }
        }
    }

    useEffect(() => {
        async function fetchConsumption() {
            const now = new Date();

            const start = format(startOfMonth(now), "yyyy-MM-dd");
            const end = format(endOfMonth(now), "yyyy-MM-dd");

            const range = `${start}|${end}`;

            try {

                const response = await getMSISDNConsumption(companyId, range, msisdn.id);
                const consumptionList = response.data;
                setConsumptionCount(consumptionList.length)
                // You can set it to state here if needed
            } catch (error) {
                console.error("Error fetching MSISDN consumption:", error);
            }
        }

        fetchConsumption();
    }, [companyId, msisdn])

    return (
        <>
            <tr>
                <td>{msisdn.fullName ?? "-"}</td>
                <td>{msisdn.id}</td>
                <td>{consumptionCount}</td>
                <td>{msisdn.note ?? "-"}</td>
                <td>
                    {lockStatus ? (
                        hasClaim(ACTIVATE_DEACTIVATE_MSISDN) ? (
                            <ConditionalRender condition={hasClaim(UPDATE_MSISDN_STATUS)}>
                                <MsisdnStatusDropdown
                                    status={currentStatus}
                                    onChange={(status) => {
                                        setPendingStatus(status);
                                        setShowChangeStatusConfirm(true);
                                    }}
                                />
                                <Fallback>
                                    <Badge
                                        className="w-100 py-2"
                                        bg={colorForStatus(currentStatus)}>
                                        {statusToString(currentStatus, t)}
                                        <FontAwesomeIcon className="ms-2" icon={lockStatus ? faLock : null}
                                            title={lockStatus ? t('status.lockedByAdmin') : ''} />
                                    </Badge>
                                </Fallback>
                            </ConditionalRender>
                        ) : (
                            <Badge className="w-100 py-2" bg={colorForStatus(currentStatus)}>
                                {statusToString(currentStatus, t)}
                                <FontAwesomeIcon className="ms-2" icon={lockStatus ? faLock : null}
                                    title={lockStatus ? t('status.lockedByAdmin') : ''} />

                            </Badge>
                        )
                    ) : (
                        <ConditionalRender condition={hasClaim(UPDATE_MSISDN_STATUS)}>
                            <MsisdnStatusDropdown
                                status={currentStatus}
                                onChange={(status) => {
                                    setPendingStatus(status);
                                    setShowChangeStatusConfirm(true);
                                }}
                            />
                            <Fallback>
                                <Badge
                                    className="w-100 py-2"
                                    bg={colorForStatus(currentStatus)}
                                >
                                    {statusToString(currentStatus, t)}
                                    <FontAwesomeIcon className="ms-2" icon={lockStatus ? faLock : null} />

                                </Badge>
                            </Fallback>
                        </ConditionalRender>
                    )}

                </td>
                {/*{msisdn.extras.map((extra) =>*/}
                {/*    <td key={extra.key}>{extra.value ?? "-"}</td>*/}
                {/*)}*/}
                <td>
                    <Menu>
                        {hasClaim(UPDATE_MSISDN) && <MenuItem text={tOperations('edit')} icon={faEdit} onClick={() => setShowChangeNameModal(true)} />}
                        {hasClaim(REG_MSISDN) && <MenuItem text={t('pages.workers.registerNewWorkerDialog.sendWelcomeSms')} icon={faCommentSms} onClick={handleSendSmsClick(msisdn.id)} />}
                        {hasClaim(MANAGE_GEOFENCE_ASSIGNMENTS) && <MenuItem text={t('pages.workers.managePlanning')} icon={faClipboard} onClick={() => {onNeedGeofences?.(); setShowZonePlanningModal(true)}} />}
                        {/* {hasClaim(ACTIVATE_DEACTIVATE_MSISDN) && <MenuItem text={lockStatus ? t('dialogs.lockUnlockDialog.unlock') : t('dialogs.lockUnlockDialog.lock')} icon={lockStatus ? faLockOpen : faLock}
                            onClick={() => {
                                setLockActionSuggested(null);
                                setShowLockUnlockStatus(true)
                            }}
                        />} */}
                        {hasClaim(VIEW_MSISDN_LOCATIONS) && <MenuItem text={t('pages.workers.viewLocationsDialog.title')} icon={faLocationDot} iconColor={'red'} onClick={() => {onNeedGeofences?.(); setShowViewLocationsModal(true)}} classNameContainer={"my-1"} />}
                        {hasClaim(UNREG_MSISDN) && <MenuItem text={tOperations('delete')} variant={'danger'} icon={faTrashCan} onClick={() => setShowConfirmDeletion(true)} />}
                    </Menu>
                </td>
            </tr>

            <ConfirmModal
                active={showConfirmDeletion}
                onCancel={() => setShowConfirmDeletion(false)}
                onConfirm={async () => {
                    setShowConfirmDeletionSpinner(true)
                    try {
                        await deleteMsisdn(msisdn.id, companyId)

                        toast.success("Deleted")
                        onMsisdnDeleted()
                    }
                    catch (error) {
                        toast.error(messageFromError(error))
                    }
                    finally {
                        setShowConfirmDeletion(false)
                        setShowConfirmDeletionSpinner(false)
                    }
                }}
                title={t('dialogs.confirmDeleteDialog.title')}
                positiveButton={{ text: t('global.operations.delete'), variant: "danger" }}
                showSpinner={showConfirmDeletionSpinner}>
                <span>{t('dialogs.confirmDeleteDialog.youAreAboutTo')} <strong style={{ color: 'red' }}>{t('dialogs.confirmDeleteDialog.delete')}</strong> <FontAwesomeIcon icon={faAddressCard} className="ms-1" /> {msisdn.id}. {t('dialogs.confirmDeleteDialog.areYouSure')}</span>
            </ConfirmModal>

            <ConfirmModal
                active={showLockUnlockStatus}
                onCancel={() => setShowLockUnlockStatus(false)}
                onConfirm={async () => {
                    setShowConfirmDeletionSpinner(true)
                    try {
                        const shouldLock = lockActionSuggested !== null ? lockActionSuggested : !lockStatus;
                        await lockUnlockAccount(shouldLock);
                    } catch (error) {
                        toast.error(messageFromError(error));
                    } finally {
                        setShowLockUnlockStatus(false);
                        setShowConfirmDeletionSpinner(false);
                        setLockActionSuggested(null);
                    }
                }}
                title={
                    (lockActionSuggested ?? !lockStatus)
                        ? t('dialogs.lockUnlockDialog.lockTitle')
                        : t('dialogs.lockUnlockDialog.unlockTitle')
                }
                positiveButton={{
                    text: (lockActionSuggested ?? !lockStatus)
                        ? t('dialogs.lockUnlockDialog.lockButton')
                        : t('dialogs.lockUnlockDialog.unlockButton'),
                    variant: (lockActionSuggested ?? !lockStatus) ? 'danger' : 'success'
                }}
                showSpinner={showConfirmDeletionSpinner}
            >
                <span>
                    {(lockActionSuggested ?? !lockStatus)
                        ? t('dialogs.lockUnlockDialog.lockConfirm', { id: msisdn.id })
                        : t('dialogs.lockUnlockDialog.unlockConfirm', { id: msisdn.id })}
                </span>
            </ConfirmModal>

            <ConfirmModal
                active={showChangeStatusConfirm}
                onCancel={() => {
                    setShowChangeStatusConfirm(false);
                    setPendingStatus(null);
                }}
                onConfirm={async () => {
                    setShowConfirmDeletionSpinner(true);
                    try {
                        await updateStatus(pendingStatus);
                    } catch (error) {
                        toast.error(messageFromError(error));
                    } finally {
                        setShowConfirmDeletionSpinner(false);
                        setShowChangeStatusConfirm(false);
                        setPendingStatus(null);
                    }
                }}
                title="Confirm status change"
                positiveButton={{
                    label: "Confirm",
                }}
                showSpinner={showConfirmDeletionSpinner}
            >
                <span>
                    Are you sure you want to change the status to{" "}
                    <strong>{statusToString(pendingStatus, t)}</strong>?
                </span>

            </ConfirmModal>


            <ActionModal
                func={update}
                active={showChangeNameModal}
                hideOnConfirm
                onCancel={() => {
                    setShowChangeNameModal(false)
                }}
                onConfirm={() => {
                    toast.success("Updated");
                    onUpdated && onUpdated()
                }}
                title={t("pages.workers.editDialog.title")}
                positiveButton={{
                    text: t('global.operations.update'),
                    variant: 'success'
                }}>

                <Container fluid>
                    <Row>
                        <Col className={'p-0 pe-2'}>
                            <FormLabel>{t('dialogs.firstName')}</FormLabel>
                            <FormControl type='text' placeholder={t('dialogs.nameOptional')} style={{ resize: 'none' }} value={name.firstName} onChange={(e) => { setName({ ...name, firstName: e.target.value }) }} />
                        </Col>
                        <Col className={'p-0 ps-2'}>
                            <FormLabel>{t('dialogs.prefixName')}</FormLabel>
                            <FormControl type='text' placeholder={t('dialogs.nameOptional')} style={{ resize: 'none' }} value={name.middleName} onChange={(e) => { setName({ ...name, middleName: e.target.value }) }} />
                        </Col>
                    </Row>
                    <Row className={'mt-3'}>
                        <Col className={'p-0 pe-2'}>
                            <FormLabel>{t('dialogs.lastName')}</FormLabel>
                            <FormControl type='text' placeholder={t('dialogs.nameOptional')} style={{ resize: 'none' }} value={name.lastName} onChange={(e) => { setName({ ...name, lastName: e.target.value }) }} />
                        </Col>
                    </Row>
                    {/* <Row className={'mt-3'}>
                        <Col className={'p-0'}>
                            <FormLabel>External ID</FormLabel>
                            <FormControl
                                type='text'
                                placeholder="Optional external ID"
                                value={externalId}
                                onChange={(e) => setExternalId(e.target.value)}
                            />
                        </Col>
                    </Row> */}
                </Container>

                <div className='my-2' />
                <FormLabel>{t('dialogs.note')}</FormLabel>
                <FormControl as='textarea' rows={1} placeholder={t('dialogs.noteOptional')} value={note} onChange={(e) => {
                    setNote(e.target.value)
                }} style={{ maxHeight: "150px" }} />
                <ExtrasComponent extras={msisdn.extras} onChange={setExtrasList} />
            </ActionModal>

            <MsisdnLocationsModal
                show={showViewLocationsModal}
                onDismiss={() => setShowViewLocationsModal(false)}
                msisdn={msisdn}
                geofences={geofences}
            />


            <ManageZonePlanningModal msisdn={msisdn} geofences={geofences} show={showZonePlanningModal} onHide={() => setShowZonePlanningModal(false)} />
        </>
    )
}